import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SetLicensesForUser as SetLicensesForUserMutation,
    SetLicensesForUserVariables as SetLicensesForUserMutationVariables,
    SetLicensesForUserInput,
} from 'nutshell-graphql-types';

import SET_LICENSES_FOR_USER from '../mutations/set-licenses-for-user.graphql';

export function useSetLicensesForUser(): {
    setLicensesForUser: (arg1: SetLicensesForUserInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [licensesForUserUpdate, {loading: isLoading, error}] = useMutation<
        SetLicensesForUserMutation,
        SetLicensesForUserMutationVariables
    >(SET_LICENSES_FOR_USER);

    return {
        setLicensesForUser: (input: SetLicensesForUserInput) =>
            licensesForUserUpdate({
                variables: {input},
            }),
        isLoading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
